import type { AxiosError } from "axios";

export const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

export const clearAuthSession = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
};

export const redirectToLogin = () => {
  clearAuthSession();
  window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

const isSerayatApiNetworkError = (error: AxiosError) => {
  if (error.code !== "ERR_NETWORK" || error.response || !error.config) {
    return false;
  }

  try {
    const requestUrl = new URL(
      error.config.url || "",
      error.config.baseURL || window.location.origin
    );
    const hasAuthSession =
      Boolean(localStorage.getItem("access_token")) ||
      Boolean(localStorage.getItem("user"));

    return requestUrl.origin === "https://ser.100gan.ir" && hasAuthSession;
  } catch {
    return false;
  }
};

export const handleUnauthorizedError = (error: AxiosError) => {
  // The API currently omits CORS headers from some 401 responses. Browsers then
  // expose them to Axios as ERR_NETWORK/status 0, despite showing 401 in DevTools.
  if (error.response?.status === 401 || isSerayatApiNetworkError(error)) {
    redirectToLogin();
  }

  return Promise.reject(error);
};
